import { mdiChevronUp } from '@mdi/js'
import Icon from '@mdi/react'
import type { IconProps } from '.'

const ChevronUp = (props: IconProps) => (
    <Icon
        data-testid="IconButton__ChevronUp"
        path={mdiChevronUp}
        size={1}
        {...props}
    />
)

export default ChevronUp
